import { AutogenLayoutTieredStopPayList } from "./autogen/AutogenLayoutTieredStopPayList";
import { TableAction, TableContentsChangedEvent } from "@mcleod/components";

export class TieredStopPayList extends AutogenLayoutTieredStopPayList {
    onLoad(): void | Promise<void> {
        this.tableTieredStopPay.addContentsChangedListener((event: TableContentsChangedEvent) => {
            if (event.getAction() === TableAction.ADD) {
                this.mainDataSource.search(this.mainDataSource.lastSearch);
            }
        })
    }
}
